import dayjs from 'dayjs'

import audiLogo from '../assets/images/brands/audi.png'
import cupraLogo from '../assets/images/brands/cupra.png'
import seatLogo from '../assets/images/brands/seat.png'
import skodaLogo from '../assets/images/brands/skoda.png'
import volkswagenLogo from '../assets/images/brands/vw.png'

const eventBrands = {
  V: { name: 'VOLKSWAGEN', logo: volkswagenLogo },
  A: { name: 'AUDI', logo: audiLogo },
  S: { name: 'SEAT', logo: seatLogo },
  U: { name: 'CUPRA', logo: cupraLogo },
  C: { name: 'ŠKODA', logo: skodaLogo },
  L: { name: 'VOLKSWAGEN GOSPODARSKA VOZILA', logo: volkswagenLogo },
  H: { name: 'PORSCHE CROATIA', logo: null },
  X: { name: 'OSTALO', logo: null },
}

export const vehiclePurposeOptions = [
  { title: 'IT', value: 'it' },
  { title: 'Postprodaja', value: 'after-sales' },
  { title: 'Veliki kupci', value: 'vip' },
  { title: 'Novinari', value: 'press' },
]

export function datetime (date = new Date()) {
  return dayjs(date).valueOf()
}

export function getPageCount (totalResults, perPage) {
  return Math.max(1, Math.ceil(totalResults / perPage))
}

export function createClientId (prefix = 'record') {
  return `${prefix}-${crypto.randomUUID()}`
}

export async function downloadResponseFileAsync (response, fallbackFileName) {
  const disposition = response.headers.get('Content-Disposition') ?? ''
  const encodedName = disposition.match(/filename\*\s*=\s*([^;]+)/i)?.[1]?.trim().replace(/^"|"$/g, '')
  const plainName = disposition.match(/filename\s*=\s*(?:"([^"]+)"|([^;]+))/i)
  let fileName = plainName?.[1] ?? plainName?.[2]?.trim() ?? fallbackFileName

  if (encodedName) {
    try {
      fileName = decodeURIComponent(encodedName.replace(/^[^']*'[^']*'/, ''))
    } catch (error) {
      console.error('Invalid download file name in Content-Disposition.', error)
    }
  }

  const downloadUrl = URL.createObjectURL(await response.blob())
  const downloadLink = document.createElement('a')
  downloadLink.href = downloadUrl
  downloadLink.download = fileName
  downloadLink.click()
  URL.revokeObjectURL(downloadUrl)
}

export function getEventBrandName (brandCode) {
  return eventBrands[brandCode]?.name ?? 'NEPOZNATA MARKA'
}

export function getVehicleDisplayName (vehicle, format = 'plate-first') {
  const brandName = getEventBrandName(vehicle.brandCode ?? vehicle.vehicleBrandCode)
  const name = vehicle.name ?? vehicle.vehicleName
  const plate = vehicle.plate ?? vehicle.vehiclePlate

  if (format === 'brand-first') {
    return `${brandName} ${name}, ${plate}`
  }

  return `${plate} - ${brandName[0]}${brandName.slice(1).toLocaleLowerCase('hr-HR')} - ${name}`
}

export function getEventBrandLogo (brandCode) {
  return eventBrands[brandCode]?.logo ?? null
}

export function getEventBrandOptions () {
  return Object.entries(eventBrands)
    .filter(([value]) => value !== 'X')
    .map(([value, { name: title }]) => ({ title, value }))
}

export function getVehicleBrandOptions () {
  return Object.entries(eventBrands)
    .filter(([value]) => value !== 'H')
    .map(([value, { name: title }]) => ({ title, value }))
}

export function formatDate (date) {
  return date.split('-').reverse().join('.')
}

export function formatDateTime (timestamp) {
  return timestamp ? dayjs(timestamp).format('DD.MM.YYYY, HH:mm') : '-'
}

export function formatDateTimeInputValue (date = new Date()) {
  return dayjs(date).format('YYYY-MM-DDTHH:mm')
}

export function formatIsoDateTime (date = new Date()) {
  return dayjs(date).toISOString()
}

// Returns a valid handover time when two test drives fall within the same minute.
export function getVehicleHandoverTimestamp (
  activeStartedAt,
  requestedStartedAt,
  currentDate = null
) {
  if (!activeStartedAt || !requestedStartedAt) {
    return null
  }

  const activeTimestamp = datetime(activeStartedAt)
  const requestedTimestamp = datetime(requestedStartedAt)

  if (requestedTimestamp > activeTimestamp) {
    return formatIsoDateTime(requestedStartedAt)
  }

  if (Math.floor(requestedTimestamp / 60000) !== Math.floor(activeTimestamp / 60000)) {
    return null
  }

  const currentTimestamp = currentDate ? datetime(currentDate) : 0

  return formatIsoDateTime(Math.max(activeTimestamp + 1, currentTimestamp))
}

export function getEventStatus (event) {
  const currentTimestamp = Date.now()
  const startTimestamp = new Date(`${event.startDate}T${event.startTime}`).getTime()
  const endTimestamp = new Date(`${event.endDate}T${event.endTime}`).getTime()

  if (currentTimestamp < startTimestamp) {
    return 'upcoming'
  }

  return currentTimestamp > endTimestamp ? 'past' : 'active'
}
